<div [formGroup]="form">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label class="form-label form-label-required" for="field-name" translate="Federation.Form.Name"></label>
        <input class="form-control" id="field-name" formControlName="name"
          [class.is-invalid]="form.get('name').dirty && form.get('name').invalid" type="text" />
        <form-control-feedback [field]="form.get('name')"/>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <label class="form-label form-label-required" for="field-currency-code" translate="Federation.Form.Currency"></label>
        <ng-select
          [items]="currencies$ | async"
          formControlName="currencyCode"
          bindValue="currencyCode"
          bindLabel="currencyName"
          class="ng-select-custom ng-select-custom-alt"
          [class.is-invalid]="form.get('currencyCode').dirty && form.get('currencyCode').invalid"
          notFoundText="{{ 'Forms.FieldErrorMessages.NoResult' | translate }}"
          typeToSearchText="{{ 'Actions.Search' | translate }}"
          placeholder="{{ 'Forms.SelectDefault' | translate }}"
          [class.hide-arrow]="true"
          />
        <form-control-feedback [field]="form.get('currencyCode')"/>
      </div>
    </div>
  </div>

  <div class="row align-items-center">
    <div class="col-md-6">
      <div class="form-group">
        <label class="form-label form-label-required" for="field-subsidiaryIds" translate="Federation.Form.Subsidiaries"></label>
        <multi-select
          formControlName="subsidiaryIds"
          [items]="subsidiaries$ | async"
          [config]="multiSelectConfig"
          />
        <form-control-feedback [field]="form.get('subsidiaryIds')" [messages]="customValidationMessages.SubsidiaryIds"/>
      </div>
    </div>
    <div class="col-md-6 btn-switch-form">
      <div class="form-group">
        <btn-switch
          tooltipMessage="Federation.Form.MergeSubsidiariesTooltip"
          label="Federation.Form.MergeSubsidiaries"
          formControlName="withCustomersAggregated"
          (valueChange)="toggleMerge(form.get('withCustomersAggregated').value)"
          />
        <form-control-feedback [field]="form.get('withCustomersAggregated')"/>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-6">
      <div class="form-group">
        <label class="form-label" for="field-logo">
          {{ 'NewAccount.Company.FederationLogo' | translate }}
          <i class="far fa-info-circle" ngbTooltip="{{ 'NewAccount.Company.FederationLogoTooltip' | translate }}"></i>
        </label>
        <div class="row">
          @if (!logoField.disabled && (!lastValue.logoUrl || isLogoDeletedField.value)) {
            <file-upload class="col-lg-6" formGroupName="logo"
              [form]="logoField"
              [readonly]="logoField.disabled || form.disabled"
              [config]="fileConfig"
              [delegateUpload]="false"
              buttonKey="NewAccount.Company.UploadFile"
              />
            <file-upload-instructions [config]="fileConfig" class="col-lg-6"/>
          }
          @if (lastValue.logoUrl && !isLogoDeletedField.value && !logoField.value.underlyingFile?.value) {
            <div class="file-uploader-chip">
              @if (lastValue.logoUrl) {
                <img [src]="lastValue.logoUrl" />
              }
              @if (!form.disabled) {
                <button type="button" class="file-uploader-delete" (click)="deleteLocalLogo()"></button>
              }
            </div>
          }
        </div>
        <form-control-feedback [field]="form.get('logo')"/>
      </div>
    </div>
    @if (currentUserIsSupport() && !form.get('federationId').value) {
      <div class="col-lg-6">
        <div class="form-group">
          <label class="form-label" for="field-brandingCode" translate="NewAccount.Branding"></label>
          <ng-select
            [items]="brandings()"
            [clearable]="false"
            formControlName="brandingCode"
            bindLabel="name"
            bindValue="code"
            class="ng-select-custom ng-select-custom-alt"
            />
        </div>
      </div>
    }
  </div>

  <div class="form-group mt-5">
    <div class="form-text" translate="Forms.RequiredFields"></div>
  </div>

  @if (disabled) {
    <div class="form-actions d-flex">
      <button type="button" (click)="switchEditing(true)" class="btn btn-primary mr-auto" translate>Actions.EditInformations</button>
      <button type="button" (click)="onDelete()" class="btn btn-danger" translate>Actions.Delete</button>
    </div>
  }

  @if (!disabled) {
    <div class="form-actions d-flex">
      <button type="button" (click)="onCancel()" class="btn btn-default mr-auto" translate>Actions.Cancel</button>
      <button type="button" (click)="onSubmit()" class="btn btn-primary" [disabled]="form.invalid" [translate]="form.get('federationId')?.value ? 'Actions.Save' : 'Actions.CreatePlatform'"></button>
    </div>
  }
</div>
